import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useToggleMerlinPullRequestsSourcingEnabledMutation } from "../queries.generated"
import {
  SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment,
  SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragmentDoc,
} from "../fragments.generated"

export function useToggleMerlinPullRequestsSourcing(siteId: string) {
  const [
    toggleMerlinPullRequestsSourcingEnabledMutation,
    { loading },
  ] = useToggleMerlinPullRequestsSourcingEnabledMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleMerlinPullRequestSourcing = () => {
    setError(null)
    return toggleMerlinPullRequestsSourcingEnabledMutation({
      variables: {
        siteId,
      },
      update: (proxy, { data }) => {
        if (!data?.toggleMerlinPullRequestsSourcingEnabled?.success) {
          return
        }

        const fragmentInfo = {
          id: `Site:${siteId}`,
          fragment: SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragmentDoc,
        }

        const site = proxy.readFragment<
          SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment
        >(fragmentInfo)

        if (!site) {
          return
        }

        site.merlinPullRequestsSourcingEnabled = !site.merlinPullRequestsSourcingEnabled

        proxy.writeFragment<
          SiteDetailsMerlinPullRequestsSourcingEnabledFieldsFragment
        >({
          ...fragmentInfo,
          data: site,
        })
      },
      optimisticResponse: {
        toggleMerlinPullRequestsSourcingEnabled: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleMerlinPullRequestSourcing, { loading, errorAlert }] as const
}
